module.exports = __webpack_public_path__ + "static/media/daily-ui1.08146a22.png";